import angular from 'angular';

import component from './menu-manage.component';

const MenuManage = angular.module('control-room.menu-manage', []).component('crMenuManage', component);

export default MenuManage;
